import React, { useState, useEffect, useContext } from "react";
import "./index.scss";
import { useParams } from "react-router";
import {
  checkForUserLimit,
  convertToCamelCaseFromUnderScore,
} from "../../../utils";
import { invokeApi, HTTP_METHODS } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import {
  AFTER_JIR_FORM,
  BASIC_INFO_FORM_CONFIG,
  CUT_IN,
  TICKET_STAGES,
} from "./helper";
import FormGenerator from "../../../core/form-generator";
import FormDetails from "./form-details";
import CustomButtonComponent from "../../../core/custom-button";
import { Icon } from "@iconify/react";
import moment from "moment";
import { USER_LIMITS } from "../../../utils/constants";
import AppContext from "../../../utils/context";
const BasicInfo = ({
  ticketDetails,
  serviceEngineers = [],
  loadData,
  complaintForm,
  codes,
  parts,
  setShowAttachments,
}) => {
  const { severity } = ticketDetails;
  const { id = "" } = useParams();
  const [engineer, setEngineer] = useState({});
  const [reassign, setReassign] = useState(false);
  const [formData, setFormData] = useState({});
  const [formData2, setFormData2] = useState({});
  const [errors, setErrors] = useState({});
  const [tempDate, setTempDate] = useState("");
  const [files, setFiles] = useState([]);
  const [serviceEngineerList, setServiceEngineerList] = useState([]);
  const { userDetails = {} } = useContext(AppContext);

  const updateDateOfInspection = () => {
    let payload = {
      dateOfInspection: new Date(tempDate).toISOString(),
    };
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.TICKETS}/${id}`,
      payload
    )
      .then((response) => {
        setTempDate("");
        loadData();
      })
      .catch((err) => console.error(err));
  };

  const updateSeverityInspection = (value) => {
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.TICKETS}/${id}`, {
      severity: value,
    })
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          toast.success("Ticket Severity Updated");
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    serviceEngineers &&
      setEngineer(
        serviceEngineers.find((s) => s.id === ticketDetails.serviceEngineerId)
      );
  }, [serviceEngineers]);
  const assignEngineer = () => {
    if (engineer.id === ticketDetails.serviceEngineerId) {
      setReassign(false);
      setEngineer({});
      return;
    }

    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.ASSIGN_SE}/${id}`, {
      serviceEngineerId: engineer.id,
    })
      .then((response) => {
        setEngineer({});
        setReassign(false);
        loadData();
      })
      .catch((err) => console.error(err));
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };
  const submitHandler = () => {};
  useEffect(() => {
    if (Object.keys(ticketDetails).length) {
      setFormData({
        ...ticketDetails,
        stage: TICKET_STAGES[ticketDetails.stage],
        createdAt: `${moment(ticketDetails.createdAt).format(
          "DD/MM/YYYY"
        )} ${new Date(ticketDetails.createdAt).toLocaleTimeString()}`,
        status: ticketDetails.status,
        engineSerialNumber: complaintForm?.engineSerialNumber || "",
        listNumber: ticketDetails.listNumber || "",
        oemName: ticketDetails?.oemOrg?.name || "",
        oemServiceEngineerName: complaintForm?.oemServiceEngineerName || "",
        oemServiceEngineerContact:
          complaintForm?.oemServiceEngineerContact || "",
        underWarranty: ticketDetails.underWarranty,
        engineerAssignedDate:
          moment(ticketDetails.engineerAssignedDate).format("DD/MM/YYYY") ||
          "-",
        dateOfInspection:
          moment(ticketDetails.dateOfInspection).format("DD/MM/YYYY") || "-",
        repeatedComplaint: false,
        cutInDetails:
          (complaintForm.cutInDetails &&
            CUT_IN.find((ele) => ele.value === complaintForm.cutInDetails)) ||
          "",
        extendedTechnicalSupport: ticketDetails.extendedTechnicalSupport
          ? "Yes"
          : "No",
        severity: severity,
        state: complaintForm.oemEngineLocation?.state,
        location: complaintForm.oemEngineLocation?.tractorAddress,
        customerComplaintCode: ticketDetails?.customerComplaintCode?.code,
        complaintDesc: ticketDetails?.customerComplaintCode?.description,
        defectCode: ticketDetails?.defectCode?.code,
        defectDescription: ticketDetails?.defectCode?.description,
        engineReplacementStatus: convertToCamelCaseFromUnderScore(
          ticketDetails?.engineReplacementStatus
        ),
      });
    }
    if (serviceEngineers.length) {
      const seList = serviceEngineers.map((ele) => ({
        label: ele.name,
        value: ele.id,
      }));
      setServiceEngineerList(seList);
    }
  }, [ticketDetails, serviceEngineers]);

  return (
    <div>
      <div className="form-con">
        <FormGenerator
          config={BASIC_INFO_FORM_CONFIG}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
      </div>
      {checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits) &&
        ticketDetails.status !== "CLOSED" && (
          <FormDetails
            loadData={loadData}
            codes={codes}
            parts={parts}
            ticketDetails={ticketDetails}
            serviceEngineers={serviceEngineerList}
            complaintForm={complaintForm}
          />
        )}

      {ticketDetails?.jointInspectionReport && (
        <div className="form-con page-load">
          <div className="form-header">View basic request form</div>
          <FormGenerator
            config={AFTER_JIR_FORM}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
          />
          <div>
            <p>Attachments & Conversations</p>
            <CustomButtonComponent
              variant="contained"
              onClick={() => setShowAttachments(true)}
              startIcon={<Icon icon="hugeicons:conversation" />}
            >
              See attachments and Conversations
            </CustomButtonComponent>
          </div>
        </div>
      )}
    </div>
  );
};

export default BasicInfo;
